import { Modal } from '@zambezi/sdk/modal';
import { useCase } from 'hooks/useCase';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { formatDate, formatDateTime } from 'utils';

interface CancelledDeclineModalProps {
  onClose: () => void;
}

const CancelledDeclineModal: React.FC<CancelledDeclineModalProps> = ({
  onClose
}: CancelledDeclineModalProps) => {
  const { data } = useCase();

  return (
    <Modal
      className="modal-large"
      confirm="Close"
      title="Declined / Cancelled"
      isClosable
      onConfirm={onClose}
      onCancel={onClose}
      open
    >
      <table className="case-details">
        <tbody>
          {[
            ['Expected Completion Date', formatDate(data?.mortgageSummary?.expectedCompletionDate)]
          ].map(([label, value], index) => (
            <tr key={`completion-information-${index}`}>
              <th>{label}</th>
              <td>{value || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="zb-heading3">{t('case.solicitorDetails.title')}</h3>
      <table className="case-details">
        <tbody>
          {[
            ['Solicitor Firm Name', data?.solicitorInformation?.firmName],
            ['Solicitor Contact Name', data?.solicitorInformation?.contactName],
            ['Telephone Number', data?.solicitorInformation?.contact?.phone],
            ['Email', data?.solicitorInformation?.contact?.email]
          ].map(([label, value], index) => (
            <tr key={`solicitor-details-${index}`}>
              <th>{label}</th>
              <td>{value || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {data?.mortgageSummary?.milestones?.cancelledDecline?.actionRequired.length ? (
        <>
          <h3 className="zb-heading3">{t('case.cancelledDeclineModal.actionRequired')}</h3>
          <div className="zb-has-scrollbar" style={{ maxHeight: 200, overflowY: 'scroll' }}>
            {data?.mortgageSummary.milestones.cancelledDecline.actionRequired.map(
              (action, index) => (
                <div className="record-entry" key={`action-${index}`}>
                  <div className="record-entry-content">
                    <p>{action.description}</p>
                  </div>
                  <div className="record-entry-meta">
                    <p>{formatDateTime(action.dateTime)}</p>
                  </div>
                </div>
              )
            )}
          </div>
        </>
      ) : null}

      {data?.mortgageSummary?.milestones?.cancelledDecline?.updates.length ? (
        <>
          <h3 className="zb-heading3">{t('case.completedModal.updates')}</h3>
          <div className="zb-has-scrollbar" style={{ maxHeight: 200, overflowY: 'scroll' }}>
            {data?.mortgageSummary.milestones.cancelledDecline.updates.map((update, index) => (
              <div className="record-entry" key={`update-${index}`}>
                <div className="record-entry-content">
                  <p>{update.description}</p>
                </div>
                <div className="record-entry-meta">
                  <p>{formatDateTime(update.dateTime)}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </Modal>
  );
};

export default CancelledDeclineModal;
